import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles'
import { TextField, Select, MenuItem, FormControl, InputLabel, Stack } from '@mui/material';

const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: "50%"
    }
}))

export default function RenderReportDashboardFilterForm({ reportDashboardFilter, i, filterFormStateChange }) {
    const classes = useStyles();

    let filterOperation;
    let filterValue;
    const [textAreaState, setTextAreaState] = useState("")
    const [operator, setOperator] = useState("");
    
    const handleChange = e => {
        const val = e?.target?.value
        setTextAreaState(val)
        let values = val?.split('\n');
        filterFormStateChange("operatorvalues", i, values)
    }

    const handleChangeOperator = e => {
        const val = e?.target?.value
        setOperator(val)
        filterFormStateChange("filterOperation", i, val)
    }
    

    useEffect(() => {
        // setTextAreaState(reportDashboardFilter?.values?.join("\n"));
        setOperator(reportDashboardFilter?.operator);
    }, [reportDashboardFilter.values])
    
    if (reportDashboardFilter?.type === "number" || reportDashboardFilter?.type === "count") {
        filterOperation = (
            <Select
                label="Operation"
                id={"filterOperation-" + i}
                value={operator}
                onChange={handleChangeOperator}
            >
                <MenuItem value={"equals"}>Equals</MenuItem>
                <MenuItem value={"notEquals"}>Does not equal</MenuItem>
                <MenuItem value={"gt"}>Greater than</MenuItem>
                <MenuItem value={"gte"}>Greater than or equal to</MenuItem>
                <MenuItem value={"lt"}>Less than</MenuItem>
                <MenuItem value={"lte"}>Less than or equal to</MenuItem>
            </Select>
        )
    } else if (reportDashboardFilter?.type === "string") {
        filterOperation = (
            <Select
                label="Operation"
                id={"filterOperation-" + i}
                value={operator}
                onChange={handleChangeOperator}
            >
                <MenuItem value="equals">Equals</MenuItem>
                <MenuItem value="notEquals">Does not equal</MenuItem>
                <MenuItem value="contains">Contains</MenuItem>
                <MenuItem value="notContains">Does not contain</MenuItem>
            </Select>
        )
    } else if (reportDashboardFilter?.type === "time") {
        filterOperation = (
            <Select
                label="Operation"
                id={"filterOperation-" + i}
                value={operator}
                onChange={handleChangeOperator}
            >
                <MenuItem value="equals">Equals</MenuItem>
                <MenuItem value="notEquals">Does not equal</MenuItem>
                <MenuItem value="inDateRange">In Date Range</MenuItem>
                <MenuItem value="notInDateRange">Not In Date Range</MenuItem>
                <MenuItem value="beforeDate">Before Date</MenuItem>
                <MenuItem value="afterDate">After Date</MenuItem>
            </Select>
        )
    }
    else {
        filterOperation = (
            <Select
                label="Operation"
                id={"filterOperation-" + i}
                value={operator}
                onChange={handleChangeOperator}
            >
                <MenuItem value="equals">Equals</MenuItem>
                <MenuItem value="notEquals">Does not equal</MenuItem>
            </Select>
        )
    }
    
    filterValue = (
        <TextField
            id={"operatorvalues-" + i}
            label="Value List"
            multiline
            maxRows={4}
            value={textAreaState}
            onChange={handleChange}
            variant="outlined"
        />
    )

    return (<>
        <Stack  width="100%" spacing={1} flexShrink={0} sx={{ my: 1 }}>        
            <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel htmlFor="outlined-age-native-simple">Operation</InputLabel>
                {filterOperation}
            </FormControl>
            {/* <FormControl variant="outlined" className={classes.formControl}>
                {filterValue}
            </FormControl> */}
        </Stack>
    </>)
}